module.exports = __webpack_public_path__ + "static/img/B01-辽宁省实验学校1.da55b89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/B01-辽宁省实验学校1.png
// module id = 24OQ
// module chunks = 0